<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-card class="card0">
        <h4>Bills Payment</h4>
        <v-card flat class="card2">
          <div class="cardDiv" dark v-bind="attrs" v-on="on">
            <v-card
              @click="navigate('electricity')"
              flat
              class="mx-auto cardTr bgElectricity"
              width="270"
            >
              <img
                src="../assets/light.png"
                alt="teller logo"
                width="40"
                height="60"
              />
              <div class="init">
                <h5>Electricity Bills</h5>
                <small
                  >Purchase electricity directly from your Teller app</small
                >
              </div>
            </v-card>
          </div>
          <div class="cardDiv" dark v-bind="attrs" v-on="on">
            <v-card
              @click="navigate('internet')"
              flat
              class="mx-auto cardTr bgInternet"
              width="270"
            >
              <img
                src="../assets/net.png"
                alt="teller logo"
                width="40"
                height="40"
              />
              <div class="init">
                <h5>Internet Bills</h5>
                <small>Pay for your internet bills for all networks</small>
              </div>
            </v-card>
          </div>
          <div class="cardDiv" dark v-bind="attrs" v-on="on">
            <v-card
              flat
              @click="navigate('cable')"
              class="mx-auto cardTr cable"
              width="270"
            >
              <img
                src="../assets/cable.png"
                alt="teller logo"
                width="40"
                height="40"
              />
              <div class="init">
                <h5>Cable Bills</h5>
                <small
                  >Pay and renew your cable bills from your Teller app</small
                >
              </div>
            </v-card>
          </div>
          <div class="cardDiv" dark></div>
        </v-card>
      </v-card>
    </div>
    <div class="Transaction">
      <v-card class="mx-auto card cardv" max-width="344">
        <div class="ImgTrans">
          <div class="trans">
            <h4>Recent Transactions</h4>
            <small @click="navigate('transactionHistory')">see all ></small>
          </div>
        </div>
        <div class="cardRR">
          <RecentTransactions />
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";
import RecentTransactions from "../components/RecentTransactions";

export default {
  metaInfo: {
    title: "Teller/Billspayment",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
    RecentTransactions,
  },
  methods: {
    navigate(to) {
      this.$router.push({ name: to });
    },
  },
};
</script>
<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction"
    "mainBody mainBody Transaction";
}

.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 30px;
  padding-top: 70px;
}
.mainBody h4 {
  color: #ad1684;
  margin-top: 10px;
}
.Transaction {
  grid-area: Transaction;
  background-color: #ffffff;
}
.card {
  margin-top: 50px;
  border-radius: 20px !important;
  height: 500px;
}
.cardTr {
  display: flex;
  align-items: center;
  padding: 15px;
  padding-right: 20px;
  padding-left: 20px;
  height: 100px;
  border-radius: 20px !important;
  margin-right: 20px;
  margin-left: 20px;
}
.bgElectricity {
  background-color: rgba(255, 228, 144, 0.25);
  cursor: pointer;
}
.bgInternet {
  background-color: rgba(187, 107, 217, 0.15);
  cursor: pointer;
}
.ImgTrans {
  background-image: url("../assets/Tbg.png");
  height: 140px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.trans {
  display: flex;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
}
.trans h4 {
  color: white;
}
.trans small {
  color: white;
  text-decoration-line: underline;
  cursor: pointer;
}
.card2 {
  display: flex;
  flex-wrap: wrap;
}
.cardDiv {
  width: 270px;
  flex-grow: 1;
  margin: 5px;
  margin-bottom: 20px;
}
.card0 {
  padding: 10px;
  padding-top: 20px;
  border-radius: 15px !important;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11) !important;
  background-color: #ffffff;
}
.card0 h4 {
  margin-left: 50px;
}
.cardv {
  height: 550px;
}
.cardRR {
  height: 400px;
  overflow: scroll;
  padding-bottom: 10px;
}
.cardRR::-webkit-scrollbar {
  display: none !important;
}
.init {
  margin-left: 15px;
}
.Internet {
  background-color: rgba(187, 107, 217, 0.15);
  cursor: pointer;
}
.cable {
  background-color: rgba(0, 115, 247, 0.15);
  cursor: pointer;
}

@media only screen and (max-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(90px, auto);
    margin: 0 auto;
    padding: 0px;
    grid-template-areas:
      "profileHeader profileHeader profileHeader"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody";
  }
  .Transaction {
    display: none;
  }
  img {
    width: 30px;
    height: 30px;
  }
  .card0 {
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-radius: 15px !important;
    justify-content: center;
    align-items: center;
  }
  .mainBody {
    grid-area: mainBody;
    background-color: #ffffff;
    border-bottom-left-radius: 40px;
    padding: 10px;
    padding-top: 70px;
  }
  .card0 h4 {
    margin-left: 0px;
    margin-bottom: 30px;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
